<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row no-gutters>
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'"
      >
      <TopWorkflowPeople page="boosters"/> 
      </v-col>
    </v-row>
    <v-row
      v-if="(!users || users.length == 0) && !loadingData"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyOwnersInWorkflowTitle')"
          :page-text="$t('emptyOwnersInWorkflowText')"
          page-image="image1"
        />
      </v-col>
    </v-row>

    <v-row
      v-else
      align="center"
      class="mx-auto"
    >
      <v-col
        cols="11"
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col sm="2">
                <v-avatar
                  size="55"
                  class="ml-4 mr-1"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
              </v-col>
              <v-col
                sm="9"
                md="8"
                align-self="center"
                class="pl-2 mail-name"
              >
                <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                  {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </v-card-text>
                <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                  {{ user.attributes.email }}
                </v-card-text>
              </v-col>
              <v-col
                sm="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-workflow"
                      router 
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveOwnerFromWorkflow'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveOwnerFromWorkflow'),
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                sm="2"
                md="1"
                align="center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="5"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="5"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>

              <v-col
                cols="12"
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-workflow"
                      router 
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveOwnerFromWorkflow'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveOwnerFromWorkflow'),
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <!-- <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    /> -->
    <PlusButtonWithLink
      v-if="!loadingData"
      data-testid="add-boosters-button"
      rounded="xxl"
      :link="link"
      :hide-for-free-plan="productPlan.attributes && productPlan.attributes.name == 'Free'"
      :disabled="workflow.attributes.is_broken"
    />
    <ConfirmationDialog 
      v-if="dialogVisibleRemoveUser"
      ref="confirmationDialogRemoveUser"
      :visible="dialogVisibleRemoveUser" 
      :cd-title="confirmationDialogTitle" 
      :cd-text="confirmationDialogText" 
      :cd-submit-btn="confirmationDialogSubmitBtn" 
      :cd-cancel-btn="confirmationDialogCancelBtn" 
      data-testid="confirmation-dialog-user" 
      @close="dialogVisibleRemoveUser=false"
      @proceedSubmit="removeUser(selectedUserForRemoving)"
    /> 
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import {  getOwnersInWorkflow,removeUserFromWorkflow } from '../../api/workflowApi'
//import Pagination from '../../components/Pagination'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import EmptyPage from '../../components/EmptyPage'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import TopWorkflowPeople from './TopWorkflowPeople'

export default {
    components: {
        //Pagination,
        PlusButtonWithLink,
        EmptyPage,
        ConfirmationDialog,
        AlertMessages,
        TopWorkflowPeople
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            users: [],
            usersInfo: {
                currentPage: 1,
                total: 0,
            },
            userId: window.$cookies.get('id'),
            workflowId: this.$route.params.id,
            spaceId: window.$cookies.get('space_id'),
            error:'',
            alertMsg:'',
            alertType:'',
            alertValue:false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 15,
            loadingData: false,
            dialogVisibleRemoveUser: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            link: {title: i18n.t('invitePeopleTitle'), route: '/workflow/' + this.$route.params.id + '/owners/add'},
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            isOwner:'',
            isLoading:false,
            paginationKey: '',
        }
    },
    computed: {
      productPlan() {
        return this.$store.state.productPlan;
      },
      workflow() {
        return this.$store.state.workflow
      }
    },
    async created(){
        this.loadingData = true
        await this.getWorkflow();
        await this.fetchOwnersInWorkflow()
        if(this.$route.params.ownersAddedInWorkflow){
            this.alertMsg = i18n.t('addWorkflowOwnersSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        this.loadingData = false
    },
    methods:{
        handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              this.fetchOwnersInWorkflow()
            }else {
              this.searchPeople(this.search)
            }
        },
        async fetchOwnersInWorkflow(){
            try {
                const response = await getOwnersInWorkflow(this.workflowId)
                if(response.status){
                    if(response.status == 200) {
                        this.users = response.data.data
                        window.scrollTo(0,0)
                        this.usersInfo = response.data.meta
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async removeUser(email){
            this.dialogVisibleRemoveUser = false
            try{
                let data = {
                    data: {
                        type: "workflow-users",
                        attributes: {
                            user_email: email
                        },
                    }
                }
                const response = await removeUserFromWorkflow(this.workflowId, data)
                if(response.status == 200) {
                    await this.fetchOwnersInWorkflow()
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeOwnerFromWorkflowSuccess')
                    this.$store.dispatch("getWorkflowUsersStatistics", this.workflowId)
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        },
        async getWorkflow() {
        if (this.$store.state.workflow && this.$store.state.workflow.id == this.workflowId) {
          //nothing for now
        } else {
          this.$store.dispatch("getWorkflow", this.workflowId)
            .catch(error => {
              if (error.response.status == 403) {
                this.$router.push({ name: 'PageAccessDenied' })
              }
              if (error.response.status == 404) {
                this.$router.push({ name: 'PageNotFound' })
              } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg = i18n.t('serverError')
              }
            })
        }
      },
    },
}
</script>
